var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"body-2",attrs:{"to":_vm.url}},[_vm._v(_vm._s(_vm.entityName))])}
var staticRenderFns = []

export { render, staticRenderFns }